// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"social-medias-module--social-links--3whUT","socialItem":"social-medias-module--social-item--3KjlS"};